export default "__VITE_ASSET___S_$UyPg__"